/**
 * Does an age-rate row apply to `age`? Rows come in two shapes:
 *  - legacy W&B: `{ AgeFrom, AgeTo }` (or lower-case) ranges
 *  - Plan Library / cached: `{ age, ageRange }` where `ageRange` is a single
 *    age ("35"), a band ("30-34") or an open band ("64+", "0-14")
 * A row with no age information at all does not match (previously it matched
 * everyone at the first row, i.e. the age-0 rate).
 */
export function rateRowCoversAge(r: any, age: number): boolean {
  const from = r?.AgeFrom ?? r?.ageFrom;
  const to = r?.AgeTo ?? r?.ageTo;
  if (from != null || to != null) {
    return age >= Number(from ?? 0) && age <= Number(to ?? 99);
  }
  const band = r?.ageRange ?? r?.AgeRange ?? r?.ageBand;
  if (band != null && String(band).trim() !== "") {
    const s = String(band).trim();
    let m = s.match(/^(\d+)\s*-\s*(\d+)$/);
    if (m) return age >= Number(m[1]) && age <= Number(m[2]);
    m = s.match(/^(\d+)\s*\+$/);
    if (m) return age >= Number(m[1]);
    m = s.match(/^(\d+)$/);
    if (m) {
      const n = Number(m[1]);
      // A single top age ("64") is treated as open-ended when it's the max band
      return age === n || (age > n && n >= 64);
    }
  }
  const single = r?.age ?? r?.Age;
  if (single != null) {
    const n = Number(single);
    return age === n || (age > n && n >= 64);
  }
  return false;
}
